import React, { useCallback } from 'react';
import { useFocusContext } from '../../../../contexts/FocusContext';

const FocusableInput = ({ children, elementId, ...props }) => {
  const focusContext = useFocusContext();

  const handleFocus = useCallback((e) => {
    if (focusContext) {
      focusContext.setFocused(true, elementId);
    }
    // Call original onFocus if provided
    if (props.onFocus) {
      props.onFocus(e);
    }
  }, [focusContext, elementId, props.onFocus]);

  const handleBlur = useCallback((e) => {
    if (focusContext) {
      focusContext.setFocused(false, null);
    }
    // Call original onBlur if provided
    if (props.onBlur) {
      props.onBlur(e);
    }
  }, [focusContext, props.onBlur]);

  // Clone the child element and add focus/blur handlers
  return React.cloneElement(children, {
    ...props,
    onFocus: handleFocus,
    onBlur: handleBlur,
  });
};

export default FocusableInput;